module.exports = __webpack_public_path__ + "static/img/mwd-home-logo.316e315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mwd-home-logo.svg
// module id = /7H8
// module chunks = 1